import { type SVGProps } from 'react'

export function AnnotationInfoIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#DC6803'

  return (
    <svg fill="none" height="13" viewBox="0 0 12 13" width="12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 7.4043V5.6543M6 3.9043H6.005M4.95 10.0043L5.68 10.9776C5.78856 11.1224 5.84284 11.1947 5.90938 11.2206C5.96767 11.2433 6.03233 11.2433 6.09062 11.2206C6.15716 11.1947 6.21144 11.1224 6.32 10.9776L7.05 10.0043C7.19657 9.80887 7.26986 9.71115 7.35925 9.63655C7.47844 9.53707 7.61915 9.46672 7.77025 9.43105C7.88357 9.4043 8.00571 9.4043 8.25 9.4043C8.94891 9.4043 9.29837 9.4043 9.57403 9.29012C9.94157 9.13788 10.2336 8.84586 10.3858 8.47832C10.5 8.20267 10.5 7.85321 10.5 7.1543V4.3043C10.5 3.46422 10.5 3.04418 10.3365 2.72331C10.1927 2.44107 9.96323 2.2116 9.68099 2.06779C9.36012 1.9043 8.94008 1.9043 8.1 1.9043H3.9C3.05992 1.9043 2.63988 1.9043 2.31901 2.06779C2.03677 2.2116 1.8073 2.44107 1.66349 2.72331C1.5 3.04418 1.5 3.46422 1.5 4.3043V7.1543C1.5 7.85321 1.5 8.20267 1.61418 8.47832C1.76642 8.84586 2.05843 9.13788 2.42597 9.29012C2.70163 9.4043 3.05109 9.4043 3.75 9.4043C3.99429 9.4043 4.11643 9.4043 4.22975 9.43105C4.38085 9.46672 4.52156 9.53707 4.64075 9.63655C4.73014 9.71115 4.80343 9.80887 4.95 10.0043Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
